
// src/Hooks/useIAList.js
import { useEffect, useState } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';

const useIAList = () => {
  const [iaList, setIaList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchIAList = async () => {
      try {
  const { data } = await axiosApi.get('/nis/ia-list');
  setIaList(data);
      } catch (err) {
        console.error('Error fetching IA list:', err);
        setError('Failed to load IA list');
      } finally {
        setLoading(false);
      }
    };

    fetchIAList();
  }, []);

  return { iaList, loading, error };
};

export default useIAList;
